import { SearchActions } from '../actions';
import { SearchHistoryAction } from '../actions/search-history.actions';
import { SearchState } from '../search-state';

/**
 * Максимальное количество элементов,
 * которое может храниться в списке истории
 */
const HISTORY_SIZE = 100;

export const initialState: SearchState['searchHistory'] = [];

export function reducer(
  state: SearchState['searchHistory'] = initialState,
  action: SearchHistoryAction,
): SearchState['searchHistory'] {
  switch (action.type) {
    case SearchActions.SEARCH_HISTORY_PUSH: {
      const item = action.payload;

      // если в истории уже есть элемент с таким запросом, то заменяем его на новый
      const index = state.findIndex((i) => i.text === item.text);

      if (index >= 0) {
        return [item, ...state.filter((_, i) => i !== index)];
      }

      // добавляем новый элемент в начало массива, и обрезаем последний элемент, если история переполнена
      return [item, ...(state.length < HISTORY_SIZE - 1 ? state : state.slice(0, HISTORY_SIZE - 1))];
    }

    case SearchActions.SEARCH_HISTORY_REMOVE: {
      return state.filter((i) => i.text !== action.payload.text);
    }

    case SearchActions.SEARCH_HISTORY_RESET: {
      return initialState;
    }

    case SearchActions.SEARCH_HISTORY_SET_STATE: {
      return action.payload;
    }

    default: {
      return state;
    }
  }
}
